import DetailStatTiles from "@/app/admin/_common/DetailStatTiles";
import type { Link } from "../../linksPageModel";

const numberFormat = new Intl.NumberFormat("en-US");

export default function LinkStatTiles({ link }: { link: Link }) {
  const signups = link.signups ?? { new: 0, repeat: 0, guests: [] };

  return (
    <DetailStatTiles
      columns={4}
      tiles={[
        { label: "Visits", value: numberFormat.format(link.visits ?? 0) },
        { label: "Signups", value: numberFormat.format(signups.new + signups.repeat) },
        {
          label: "New",
          value: numberFormat.format(signups.new),
          caption: "First-time signups",
        },
        {
          label: "Repeat",
          value: numberFormat.format(signups.repeat),
          caption: "Returning guests",
        },
      ]}
    />
  );
}
